// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.wallacy",
    name: "Wallacy",
    homepage: "https://wallacy.io",
    image_id: "9496c3d8-8b60-495f-bd55-c3af19519d00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/wallacy-crypto-btc-wallet/id6448592576",
        android: "https://play.google.com/store/apps/details?id=io.wallacy.cryptowallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "wallacy://",
        universal: null,
    },
    desktop: {
        native: "wallacy://",
        universal: null,
    },
};
//# sourceMappingURL=index.js.map